export default "__VITE_ASSET__Ch8ChArE__"